import ahsanSajid from "@/assets/ahsan-sajid.png";

export const DepartmentalAutonomyFounderQuote = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex flex-col sm:flex-row gap-4 items-start">
        <img 
          src={ahsanSajid} 
          alt="Ahsan Sajid" 
          className="w-16 h-16 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-lg text-foreground italic mb-3">
            "I used to think I was being helpful by jumping into Slack channels and giving developers direct feedback. What I was actually doing was telling my IT Director his opinion didn't matter. The day I committed to going through him for everything—even when it felt slower—was the day the team started truly performing."
          </blockquote>
          <div>
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
